'use client';

import { Factory, Building2 } from 'lucide-react';
import { SectionHeader, VendorContactsList } from '../shared';
import type { ContactSummary } from '@/lib/api/types';

interface Party {
  name?: string;
  semantic_id?: string;
  contacts?: ContactSummary[];
}

interface PartySectionProps {
  party: Party | Party[] | string | null | undefined;
  label?: string | null;
  showContacts?: boolean;
}

export function PartySection({ party, label, showContacts = false }: PartySectionProps) {
  if (!party) {
    return null;
  }

  // Normalise to array
  const parties: Party[] = Array.isArray(party)
    ? party
    : [typeof party === 'string' ? { name: party } : party];

  const validParties = parties.filter((p) => p.name);
  if (validParties.length === 0) return null;

  return (
    <div className="p-2 rounded-lg bg-card border border-border">
      {label && <SectionHeader title={label} />}
      <div className="flex flex-col gap-1">
        {validParties.map((p, i) => (
          <div key={p.semantic_id || i}>
            <div className="flex items-center gap-2 text-xs">
              <Factory className="h-3 w-3 text-muted-foreground shrink-0" />
              <span className="font-medium truncate">{p.name}</span>
            </div>
            {showContacts && p.contacts && p.contacts.length > 0 && (
              <VendorContactsList contacts={p.contacts} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
